import React, { useEffect } from 'react'
import { useValidatorSeeker } from "@ui-seeker/app"
import { array, object } from "yup"

import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { AppSitesAutocomplete } from "@components"
import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function AlertsSitesRequired({ ...props }) {

	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().sites || [])

	const { errors, isValid } = useValidatorSeeker({ sites: dataInfo.value }, object({
		sites: array().min(1, 'Must provide at least one site')
	}))

	useEffect(() => {
		alertsDrawerErrors.value = { ...alertsDrawerErrors.value, sites: isValid }
	}, [JSON.stringify(errors)])

	return <AppSitesAutocomplete
		value={dataInfo.value}
		onChange={e => setDataInfo(e.target.value, 'sites')}
		error={errors.sites}
		{...props}
	/>
}
